import { ReactNode, MouseEvent } from "react"
import { Tag as AntTag } from "antd"
import { TagProvider } from "components/providers/Tag.provider"

type Props = {
	children: ReactNode
	bordered?: boolean
	closeIcon?: ReactNode
	className?: string
	onClose?: (e: MouseEvent<HTMLElement>) => void | undefined
	onClick?: (e: MouseEvent<HTMLElement>) => void | undefined
}

export const Tag = ({ children, bordered = false, closeIcon, onClose, onClick, className }: Props) => {
	return (
		<TagProvider>
			<AntTag bordered={bordered} closeIcon={closeIcon} onClose={onClose} onClick={onClick} className={className}>
				<span data-testid="tag">{children}</span>
			</AntTag>
		</TagProvider>
	)
}
